// Bulk Import route — gated behind VITE_FF_BULK_IMPORT.
// -----------------------------------------------------------------
// Ports admin/routes/bulk_import.py to a SPA-direct Firestore page.
// When the flag is off (default in both staging and prod), the route
// mounts and immediately <Navigate replace />s to /hello, matching
// the M3.4 placeholder pattern used by other feature-flagged routes.

import { Navigate, createFileRoute } from '@tanstack/react-router';

import { BulkImportPage } from '@/components/bulk-import/BulkImportPage';
import { isFeatureEnabled } from '@/lib/featureFlags';

const BulkImportRoute = () => {
  if (!isFeatureEnabled('BULK_IMPORT')) {
    return <Navigate to='/hello' replace />;
  }
  return <BulkImportPage />;
};

export const Route = createFileRoute('/_authenticated/bulk-import')({
  component: BulkImportRoute,
});
